import { Injectable } from '@angular/core';
import { COMPANY_FEATURE_LAZY, DaDataResponse, RawCompanyData, UserCompany } from '@company/const';
import { facadeFactory } from '@spartacus/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
  useFactory: () =>
    facadeFactory({
      facade: CompanyService,
      feature: COMPANY_FEATURE_LAZY,
      methods: [
        'searchCompany',
        'getSearchCompanyLoading',
        'getSearchCompanyResult',
        'resetSearchCompanyResult',
        'addCompany',
        'getAddCompanyLoading',
        'getAddedCompanyUid',
        'resetAddedCompany',
        'selectCompany',
        'getSelectedCompany',
        'getSelectedCompanyUid',
        'resetSelectedCompany',
        'removeCompany',
        'getRemoveCompanyLoading',
        'loadUserCompanies',
        'getUserCompaniesLoading',
        'getUserCompanies',
      ],
      async: true,
    }),
})
export abstract class CompanyService {
  abstract searchCompany(query: string): void;

  abstract getSearchCompanyLoading(): Observable<boolean>;

  abstract getSearchCompanyResult(): Observable<DaDataResponse[]>;

  abstract resetSearchCompanyResult(): void;

  abstract addCompany(company: RawCompanyData): void;

  abstract getAddCompanyLoading(): Observable<boolean>;

  abstract getAddedCompanyUid(): Observable<string | undefined>;

  abstract resetAddedCompany(): void;

  abstract selectCompany(companyUid: string): void;

  abstract getSelectedCompany(): Observable<UserCompany | undefined>;

  abstract getSelectedCompanyUid(): Observable<string | undefined>;

  abstract resetSelectedCompany(): void;

  abstract removeCompany(companyUid: string): void;

  abstract getRemoveCompanyLoading(): Observable<boolean>;

  abstract loadUserCompanies(): void;

  abstract getUserCompaniesLoading(): Observable<boolean>;

  abstract getUserCompanies(): Observable<UserCompany[]>;
}
